<template>
  <div>
    <div class="container-fluid">
      <!-- Content goes here -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
